import React from 'react'
import { Icon, IconProps } from '@chakra-ui/icon'
import { useColorModeValue } from '@chakra-ui/color-mode'

export function ReptileIcon(props: IconProps) {
    return useColorModeValue(<Outline {...props} />, <Fill {...props} />)
}

const Outline: React.FC<IconProps> = props => (
    <Icon viewBox="0 0 72 72" fill="none" {...props}>
        <path
            d="M14.7656 59.2031C12.4357 59.2031 10.5469 57.3143 10.5469 54.9844V50.7656H14.7656C17.0955 50.7656 18.9844 52.6545 18.9844 54.9844C18.9844 57.3143 17.0955 59.2031 14.7656 59.2031Z"
            stroke="currentColor"
            strokeWidth="4.21875"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M14.7656 42.3281C21.7447 42.3281 27.4219 48.0053 27.4219 54.9844C27.4219 62.7885 20.3231 68.9648 12.2431 67.3952C6.23447 66.2282 2.10938 60.6057 2.10938 54.4847V33.8906C2.10938 17.5809 15.3309 4.35938 31.6406 4.35938"
            stroke="currentColor"
            strokeWidth="4.21875"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M28.8025 8.74829L28.3338 4.54248"
            stroke="currentColor"
            strokeWidth="4.21875"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M18.191 12.4784L15.9271 8.88251"
            stroke="currentColor"
            strokeWidth="4.21875"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M10.2283 20.4412L6.63242 18.1771"
            stroke="currentColor"
            strokeWidth="4.21875"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M6.49834 31.0526L2.29239 30.5839"
            stroke="currentColor"
            strokeWidth="4.21875"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M69.8906 33.8906V25.4531C69.8906 13.7426 60.207 4.2608 48.4736 4.36023C46.2184 4.37935 44.4375 6.32279 44.4375 8.57813V17.0156C44.4375 10.0257 38.6305 4.35938 31.6406 4.35938"
            stroke="currentColor"
            strokeWidth="4.21875"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M61.3125 21.2344C61.3125 23.5643 59.4236 25.4531 57.0938 25.4531C54.7639 25.4531 52.875 23.5643 52.875 21.2344C52.875 18.9045 54.7639 17.0156 57.0938 17.0156C59.4236 17.0156 61.3125 18.9045 61.3125 21.2344Z"
            stroke="currentColor"
            strokeWidth="4.21875"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M18.9844 25.4531C23.6443 25.4531 27.4219 29.2307 27.4219 33.8906"
            stroke="currentColor"
            strokeWidth="4.21875"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M36 25.4531C40.6599 25.4531 44.4375 29.2307 44.4375 33.8906"
            stroke="currentColor"
            strokeWidth="4.21875"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M10.5469 50.7656V33.8906H69.8906V42.3281H50.4037L57.0937 49.0182L51.1276 54.9844L38.4713 42.3281H10.5469"
            stroke="currentColor"
            strokeWidth="4.21875"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </Icon>
)

const Fill: React.FC<IconProps> = props => (
    <Icon viewBox="0 0 72 72" fill="none" {...props}>
        <path
            d="M56.9531 23.2755C58.1181 23.2755 59.0625 22.3311 59.0625 21.1662C59.0625 20.0012 58.1181 19.0568 56.9531 19.0568C55.7881 19.0568 54.8438 20.0012 54.8438 21.1662C54.8438 22.3311 55.7881 23.2755 56.9531 23.2755Z"
            fill="currentColor"
        />
        <path
            d="M14.7656 57.0255C15.9294 57.0255 16.875 56.08 16.875 54.9162C16.875 53.7524 15.9294 52.8068 14.7656 52.8068H12.6562V54.9162C12.6562 56.0801 13.6018 57.0255 14.7656 57.0255Z"
            fill="currentColor"
        />
        <path
            d="M48.3137 2.1818C45.4957 2.20852 43.1165 4.18613 42.4038 6.84956C39.7094 3.978 35.8799 2.1818 31.6406 2.1818C31.3152 2.1818 30.9995 2.22089 30.6764 2.23074L30.8991 4.22944C31.0268 5.38706 30.1926 6.42952 29.0348 6.55917C27.8535 6.68349 26.8335 5.83608 26.7051 4.69491L26.4762 2.64136C23.7409 3.09333 21.1244 3.88477 18.6719 4.99247L19.9773 7.06585C20.5973 8.05261 20.3008 9.35438 19.3161 9.9765C18.3206 10.5971 17.0239 10.2956 16.4055 9.31528L14.9446 6.99497C12.502 8.52075 10.2888 10.3658 8.35102 12.4784L11.3524 14.3684C12.337 14.9905 12.6336 16.2924 12.0136 17.279C11.3954 18.2588 10.0991 18.5614 9.10294 17.9402L5.67956 15.7847C3.87323 18.3765 2.43492 21.241 1.46419 24.3159L4.62263 24.6679C5.78025 24.7977 6.61458 25.84 6.48689 26.9976C6.35864 28.1367 5.34094 28.9865 4.15716 28.8619L0.491203 28.4532C0.190266 30.2023 0 31.9891 0 33.8224V54.4155C0 62.6133 6.20887 69.8182 14.7409 69.8182C22.9376 69.8182 29.5312 63.048 29.5312 54.916C29.5312 50.7828 27.8132 47.0523 25.0665 44.3692H37.4579L49.4961 56.4074C50.32 57.2313 51.6549 57.2313 52.4789 56.4074L58.4445 50.4418C59.2684 49.6178 59.2684 48.2829 58.4445 47.459L55.3545 44.369H69.8906C71.0565 44.369 72 43.4256 72 42.2596V35.9315H12.6562V48.5878H14.7656C18.2551 48.5878 21.0938 51.4264 21.0938 54.9159C21.0938 58.4054 18.2551 61.244 14.7656 61.244C11.2762 61.244 8.4375 58.4054 8.4375 54.9159C8.4375 54.2454 8.4375 32.637 8.4375 33.8221C8.4375 32.6562 9.38095 31.7128 10.5469 31.7128H24.924C24.0502 29.2628 21.7308 27.494 18.9844 27.494C17.8185 27.494 16.875 26.5506 16.875 25.3846C16.875 24.2187 17.8185 23.2753 18.9844 23.2753C24.0772 23.2753 28.3378 26.9047 29.3178 31.7128H41.799C40.9253 29.2628 38.6058 27.494 35.8594 27.494C34.6935 27.494 33.75 26.5506 33.75 25.3846C33.75 24.2187 34.6935 23.2753 35.8594 23.2753C40.9523 23.2753 45.2128 26.9047 46.1928 31.7128H72V25.3846C72 12.6543 61.4595 2.13835 48.3137 2.1818ZM56.9531 27.4943C53.4637 27.4943 50.625 24.6556 50.625 21.1662C50.625 17.6767 53.4637 14.838 56.9531 14.838C60.4426 14.838 63.2812 17.6767 63.2812 21.1662C63.2812 24.6556 60.4426 27.4943 56.9531 27.4943Z"
            fill="currentColor"
        />
    </Icon>
)
